// Componente RegistrosAula com funcionalidade de edição com Modal e separação de links
import React, { useState, useEffect } from "react";
import { Form, Table, Button, Modal } from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { Icon } from "@iconify/react";

const getFileExtension = (fileUrl) => {
    if (!fileUrl || typeof fileUrl !== "string") return "";

    const cleanUrl = fileUrl.split("?")[0].split("#")[0];
    const fileName = cleanUrl.split("/").pop() || "";
    const extension = fileName.includes(".") ? fileName.split(".").pop() : "";

    return extension.toLowerCase();
};

const isPdfFile = (fileUrl) => getFileExtension(fileUrl) === "pdf";

const normalizeFileUrl = (fileUrl, defaultFolder = "") => {
    if (!fileUrl || typeof fileUrl !== "string") return "";
    if (!defaultFolder) return fileUrl;

    const normalizedFolder = defaultFolder.replace(/^\/+|\/+$/g, "");

    try {
        const parsed = new URL(fileUrl);
        const pathname = decodeURIComponent(parsed.pathname);
        const hasFolder = pathname.includes(`/${normalizedFolder}/`);

        if (!hasFolder && /^\/[^/]+$/.test(pathname)) {
            parsed.pathname = `/${normalizedFolder}${pathname}`;
            return parsed.toString();
        }

        return fileUrl;
    } catch {
        const cleanPath = fileUrl.replace(/^\/+/, "");
        return cleanPath.includes("/")
            ? fileUrl
            : `${API_BASE_URL}/${normalizedFolder}/${cleanPath}`;
    }
};

const RegistrosAula = ({ turmaId, onAtualizar, atualizarResumos }) => {
    console.log("Etapa 3: atualizarResumos recebido no RegistrosAula:", atualizarResumos);
    const [resumosPorData, setResumosPorData] = useState({});
    const [dataSelecionada, setDataSelecionada] = useState("");
    const [resumosSelecionados, setResumosSelecionados] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [resumoAtual, setResumoAtual] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [resumoParaExcluir, setResumoParaExcluir] = useState(null);
    const [showConfirmEditModal, setShowConfirmEditModal] = useState(false);
    const [showPDF, setShowPDF] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");


    const [formData, setFormData] = useState({
        resumo: "",
        aula: "",
        link: "",
        linkYoutube: "",
        arquivo: null,
    });

    const handleAbrirModalExcluir = (resumo) => {
        setResumoParaExcluir(resumo);
        setShowDeleteModal(true);
    };

    const handleViewPDF = (url, defaultFolder = "") => {
        setPdfUrl(normalizeFileUrl(url, defaultFolder));
        setShowPDF(true);
    };

    const handleOpenFile = (url, defaultFolder = "") => {
        const normalizedUrl = normalizeFileUrl(url, defaultFolder);

        if (isPdfFile(url)) {
            handleViewPDF(normalizedUrl);
            return;
        }

        window.open(normalizedUrl, "_blank", "noopener,noreferrer");
    };

    const handleClosePDF = () => {
        setShowPDF(false);
        setPdfUrl("");
    };

    useEffect(() => {
        if (turmaId) {
            fetchResumos();
        } else {
            setResumosPorData({});
            setDataSelecionada("");
            setResumosSelecionados([]);
        }
    }, [turmaId]);


    useEffect(() => {
        if (atualizarResumos) {
            console.log("Sinal recebido no RegistrosAula. Chamando fetchResumos.");
            fetchResumos();
        }
    }, [atualizarResumos]);

    useEffect(() => {
        if (dataSelecionada) {
            setResumosSelecionados(resumosPorData[dataSelecionada] || []);
        } else {
            setResumosSelecionados([]);
        }
    }, [dataSelecionada, resumosPorData]);


    const fetchResumos = async () => {
        try {
            console.log("Etapa 5: fetchResumos chamado no RegistrosAula.");
            const response = await axios.get(`${API_BASE_URL}/resumos/${turmaId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            console.log("Dados retornados do fetchResumos:", response.data); // Adicione isso
            const resumos = response.data;

            // Agrupar resumos por data
            const agrupados = resumos.reduce((acc, resumo) => {
                const data = resumo.cp_res_data;
                if (!acc[data]) acc[data] = [];
                acc[data].push(resumo);
                return acc;
            }, {});

            setResumosPorData(agrupados);
        } catch (error) {
            console.error("Erro ao buscar registros:", error);
            toast.error("Erro ao buscar registros. Tente novamente mais tarde.");
        }
    };


    const handleSelecionarData = (data) => {
        setDataSelecionada(data);
        setResumosSelecionados(resumosPorData[data] || []);
    };

    const handleAbrirModalEdicao = (resumo) => {
        setResumoAtual(resumo);
        setFormData({
            resumo: resumo.cp_res_resumo,
            aula: resumo.cp_res_aula,
            link: resumo.cp_res_link,
            linkYoutube: resumo.cp_res_link_youtube,
            arquivo: null,
        });
        setShowModal(true);
    };

    const handleFecharModal = () => {
        setShowModal(false);
        setShowConfirmEditModal(false);
        setResumoAtual(null);
        setFormData({ resumo: "", aula: "", link: "", linkYoutube: "", arquivo: null });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSalvarEdicao = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("resumo", formData.resumo);
            formDataToSend.append("aula", formData.aula);
            formDataToSend.append("link", formData.link);
            formDataToSend.append("linkYoutube", formData.linkYoutube);

            if (formData.arquivo) {
                formDataToSend.append("arquivo", formData.arquivo);
            }

            const response = await axios.put(
                `${API_BASE_URL}/resumos/${resumoAtual.cp_res_id}`,
                formDataToSend,
                {
                    headers: { 
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${localStorage.getItem('token')}`
                    },
                }
            );

            const resumoAtualizado = response.data;
            const dataResumoAtualizada = resumoAtualizado.cp_res_data || resumoAtual.cp_res_data;

            setResumosPorData((prev) => {
                const resumosDoDia = prev[dataResumoAtualizada] || [];
                const resumosAtualizados = resumosDoDia.map((resumo) =>
                    resumo.cp_res_id === resumoAtualizado.cp_res_id
                        ? resumoAtualizado
                        : resumo
                );
                return { ...prev, [dataResumoAtualizada]: resumosAtualizados };
            });

            setResumosSelecionados((prev) =>
                prev.map((resumo) =>
                    resumo.cp_res_id === resumoAtualizado.cp_res_id
                        ? resumoAtualizado
                        : resumo
                )
            );

            toast.success("Resumo editado com sucesso.");
            handleFecharModal();
            console.log("Etapa 3: Dados sendo enviados para o RegistrosAula:", resumosPorData);
            // Atualiza os resumos localmente e notifica o pai
            fetchResumos(); // Atualização local
            if (onAtualizar) onAtualizar(); // Notifica o pai
        } catch (error) {
            console.error("Erro ao editar resumo:", error);
            console.error("Detalhes do erro ao editar resumo:", {
                status: error?.response?.status || null,
                data: error?.response?.data || null,
                message: error?.message || null,
            });
            toast.error("Erro ao editar resumo. Tente novamente mais tarde.");
        }
    };

    const handleExcluirResumo = async () => {
        if (!resumoParaExcluir) return;
        try {
            await axios.delete(`${API_BASE_URL}/resumos/${resumoParaExcluir.cp_res_id}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            toast.success("Resumo excluído com sucesso.");
            fetchResumos();
        } catch (error) {
            console.error("Erro ao excluir resumo:", error);
            toast.error("Erro ao excluir resumo. Tente novamente mais tarde.");
        } finally {
            setShowDeleteModal(false);
            setResumoParaExcluir(null);
        }
    };


    return (
        <div className="resumos-registro">
            {/* Dropdown para selecionar a data */}
            <h5 className="mb-1 text-theme-primary">Registro de Conteúdo</h5>
            <Form.Select
                onChange={(e) => handleSelecionarData(e.target.value)}
                className="mb-1"
            >
                <option value="">Selecione uma data</option>
                {Object.keys(resumosPorData).map((data) => (
                    <option key={data} value={data}>
                        {dayjs(data).format("DD/MM/YYYY")}
                    </option>
                ))}
            </Form.Select>

            {/* Lista de resumos em cards */}
            <div className="d-flex flex-column">
                {resumosSelecionados.length > 0 ? (
                    resumosSelecionados.map((resumo) => (
                        <div key={resumo.cp_res_id} className="py-3 border-bottom">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="fw-bold mb-0 text-theme-primary d-flex align-items-center gap-2">
                                    <Icon icon="mdi:book-open-page-variant-outline" className="text-primary" />
                                    {resumo.cp_res_aula || "Aula sem título"}
                                </h6>
                                <div className="d-flex gap-1">
                                    <Button
                                        variant="light"
                                        size="sm"
                                        className="btn-icon rounded-circle text-primary border-0"
                                        onClick={() => handleAbrirModalEdicao(resumo)}
                                        title="Editar"
                                    >
                                        <Icon icon="mdi:pencil" width="18" />
                                    </Button>
                                    <Button
                                        variant="light"
                                        size="sm"
                                        className="btn-icon rounded-circle text-danger border-0"
                                        onClick={() => handleAbrirModalExcluir(resumo)}
                                        title="Excluir"
                                    >
                                        <Icon icon="mdi:trash-can-outline" width="18" />
                                    </Button>
                                </div>
                            </div>

                            <p className="text-muted small mb-2">{resumo.cp_res_resumo}</p>

                            <div className="d-flex flex-wrap gap-2">
                                {resumo.cp_res_link && (
                                    <a
                                        href={
                                            resumo.cp_res_link.startsWith("http")
                                                ? resumo.cp_res_link
                                                : `http://${resumo.cp_res_link}`
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-sm btn-link text-decoration-none p-0 d-flex align-items-center gap-1"
                                        style={{ fontSize: '0.85rem' }}
                                    >
                                        <Icon icon="mdi:link-variant" /> Link
                                    </a>
                                )}
                                {resumo.cp_res_link_youtube && (
                                    <a
                                        href={
                                            resumo.cp_res_link_youtube.startsWith("http")
                                                ? resumo.cp_res_link_youtube
                                                : `http://${resumo.cp_res_link_youtube}`
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-sm btn-link text-danger text-decoration-none p-0 d-flex align-items-center gap-1"
                                        style={{ fontSize: '0.85rem' }}
                                    >
                                        <Icon icon="mdi:youtube" /> Vídeo
                                    </a>
                                )}
                                {resumo.cp_res_arquivo && (
                                    <button
                                        type="button"
                                        onClick={() => handleOpenFile(resumo.cp_res_arquivo, "materialdeaula")}
                                        className="btn btn-sm btn-link text-secondary text-decoration-none p-0 d-flex align-items-center gap-1"
                                        style={{ fontSize: '0.85rem' }}
                                    >
                                        <Icon icon="mdi:file-document-outline" /> Material
                                    </button>
                                )}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center py-4 text-muted">
                        <p className="mb-0 small">Nenhum registro encontrado.</p>
                    </div>
                )}
            </div>


            {/* Modal para editar resumo */}
            <Modal show={showModal} onHide={handleFecharModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Resumo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Resumo</Form.Label>
                            <Form.Control
                                type="text"
                                name="resumo"
                                value={formData.resumo}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Aula</Form.Label>
                            <Form.Control
                                type="text"
                                name="aula"
                                value={formData.aula}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type="text"
                                name="link"
                                value={formData.link}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Link do YouTube</Form.Label>
                            <Form.Control
                                type="text"
                                name="linkYoutube"
                                value={formData.linkYoutube}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Material</Form.Label>
                            <Form.Control
                                type="file"
                                name="arquivo"
                                onChange={(e) => setFormData({ ...formData, arquivo: e.target.files[0] })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleFecharModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={() => setShowConfirmEditModal(true)}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showConfirmEditModal} onHide={() => setShowConfirmEditModal(false)} centered contentClassName="border-0 shadow-lg rounded-4">
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fw-bold">Confirmar Edição</Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4 text-center">
                    <div className="mb-3 mx-auto rounded-circle d-flex align-items-center justify-content-center bg-primary-subtle text-primary" style={{ width: 64, height: 64 }}>
                        <Icon icon="mdi:pencil-outline" width="32" />
                    </div>
                    <p className="mb-0">Deseja salvar as alterações deste resumo?</p>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-center pb-4">
                    <Button variant="light" onClick={() => setShowConfirmEditModal(false)} className="rounded-pill px-4">
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            setShowConfirmEditModal(false);
                            handleSalvarEdicao();
                        }}
                        className="rounded-pill px-4"
                    >
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Exclusão</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja excluir o resumo "{resumoParaExcluir?.cp_res_resumo}"?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={handleExcluirResumo}>
                        Excluir
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showPDF}
                onHide={handleClosePDF}
                centered
                fullscreen
                className="bg-dark text-white material-pdf-modal"
            >
                <Modal.Header className="bg-dark border-0 d-flex justify-content-end p-2">
                    <Button
                        variant="light"
                        onClick={handleClosePDF}
                        className="btn-close-white material-modal-close"
                    >
                        X
                    </Button>
                </Modal.Header>
                <Modal.Body className="p-0 material-modal-body">
                    {pdfUrl && (
                        <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl)}&embedded=true`}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            title="PDF Viewer"
                            className="material-modal-iframe"
                        />
                    )}
                </Modal.Body>
            </Modal>

        </div>
    );
};

export default RegistrosAula;
